import * as React from 'react';
import Svg, { type SvgProps, Rect, Path } from 'react-native-svg';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();
export function Check(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Rect width={24} height={24} rx={12} fill={theme.colors['surface.success.subtle']} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.58 7.86C18.13 8.35 18.14 9.15 17.61 9.65L10.33 16.5L6.39 12.79C5.86 12.29 5.87 11.49 6.42 11C6.97 10.51 7.84 10.52 8.38 11.02L10.33 12.86L15.62 7.88C16.16 7.38 17.03 7.37 17.58 7.86Z"
        fill="#2B8176"
      />
    </Svg>
  );
}
export default Check;
